/*************************************************************************
 *
 * KLEARNOW CONFIDENTIAL
 * __________________
 *
 *  Copyright (c) 2018 - 2020 KLEARNOW Corporation.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of KLEARNOW Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KLEARNOW Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KLEARNOW Corporation.
 */

import React, { Component } from "react";
import { Form, Icon, Popup } from "semantic-ui-react";
import { propsAreEqual_NoRerenderNeeded } from '../../CBP_App/reducer/util'
import _ from 'lodash';

export class InputField extends Component {
  constructor() {
    super();
    this.state = {};
  }
  

  shouldComponentUpdate(nextProps, nextState){
    if(window.slowstate)return true;
     return !propsAreEqual_NoRerenderNeeded(this.props,nextProps) || !_.isMatch(this.state,nextState);

  }
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.newValue !== this.state.newValue ||
      nextProps.rbCounterId !== this.state.rbCounterId
    ) {
      this.setState(
        { newValue: nextProps.newValue, rbCounterId: nextProps.rbCounterId },
        () => {
          this.props.fieldName === this.props.id + this.props.shipmentId &&
            this.props.onChange &&
            this.props.onChange(
              this.props.isInteger
                ? parseFloat(
                    this.state.newValue.replace(/[^\d.-]/g, "")
                  ).toFixed(2)
                : this.state.newValue
            );
        }
      );
    }
  }

  errorPopup = (errors, label) => {
    let label1 = <label className="name-label no-margin es" style={{ width: "100%" }}>
    <span
      style={{ width: "90%", overflow: "ellipsis" }}
      // title={label}
    > {label}
    
      {!!this.props.info && <Popup
                              offset={[0, 50]}
                              position='left center'
            trigger={
              <Icon
                name="info circle"
                // size="small"
                style={{ fontSize: "10px" }}
                color="blue"
              />
            }
            style={{ zIndex: 9999999 }}
            content={this.props.htmlstring}
          />}
    </span>
  </label>
    if (!errors) {
      return label1;
    } else if (!errors.length) {
      return label1;
    }
    const error = errors.map((info, index) => {
      return (
        <div className="error" key={index}>
          * {info}
        </div>
      );
    });
    return (
      <label className="name-label no-margin es" style={{ width: "100%" }}>
        <span
          style={{ width: "90%", overflow: "ellipsis" }}
          // title={label}
        >
          <Popup
            trigger={
              <Icon
                name="warning sign"
                // size="small"
                style={{ fontSize: "10px" }}
                color="red"
              />
            }
            content={error || ""}
            style={{ zIndex: 9999999 }}
          />
          
          {label}
          {!!this.props.info && <Icon name="info circle"  />}
        </span>
      </label>
    );
  };

  emptyField = (id) => {
    !this.props.isInteger && this.props.onChange("");
    let element = document.getElementById(id);
    element.focus();
  };
  render() {
    const {
      id,
      iconPosition,
      width,
      type,
      onChange,
      onBlur,
      disabled,
      value,
      setINPUTID,
      penClicked,
      isInteger,
      shipmentId,
      handleFocus,
      errors,
      label,
      numberOnly,
      className,
      label2,
      readOnly,
      placeholder = "",
      maxLength,
      info,
      htmlstring
    } = this.props;
    let newLabel =  this.errorPopup(errors, label);
    return (
      <>
      <Form.Input
        label={newLabel}
        value={value === "_BLANK_" ? "" : value}
        width={width}
        iconPosition={iconPosition}
        id={id + shipmentId}
        name={id + shipmentId}
        type={type}
        title={value}
        className={
          (((errors == "Mandatory !") || errors?.length) ? " redBgColor ": " ")+className
        }
        placeholder={placeholder}
        maxLength={maxLength}
        onChange={(event) => {
          if (disabled) return;
          if (!onChange) return;
          if (numberOnly) {
            onChange(event.target.value.replace(/[^\d]/g, ""));
          } else {
            onChange(event.target.value);
          }
        }}
        onBlur={(event) => {
          if (disabled) return;
          if (isInteger && !event.target.value) {
            onChange("0.00");
          }
          onBlur && onBlur(event.target.value);
        }}
        disabled={disabled}
        readOnly={readOnly}
        onMouseDown={(e) => {
          e.stopPropagation();
          penClicked && penClicked(e);
        }}
        onFocus={(event) => {
          event.target && event.target.setAttribute("autocomplete", "nope");
          handleFocus && handleFocus(event);
          setINPUTID && setINPUTID(id + shipmentId);
        }}
      />
      </>
    );
  }
}

export default InputField;
